var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHosting3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 56 52",
    width: 56,
    height: 52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M51 7L38 7L38 5L51 5L51 5L51 7ZM51 4L38 4L37 4L37 5L37 7L37 8L38 8L51 8L52 8L52 7L52 5L52 4L52 4L51 4Z",
    id: "a1tY6m9AsZ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 7L17 7L17 5L19 5L19 5L19 7ZM19 4L17 4L16 4L16 5L16 7L16 8L17 8L19 8L20 8L20 7L20 5L20 4L20 4L19 4Z",
    id: "c1VTy7pOB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 7L11 7L11 5L13 5L13 5L13 7ZM13 4L11 4L10 4L10 5L10 7L10 8L11 8L13 8L14 8L14 7L14 5L14 4L14 4L13 4Z",
    id: "bSLsf6jAl"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 7L5 7L5 5L7 5L7 5L7 7ZM7 4L5 4L4 4L4 5L4 7L4 8L5 8L7 8L8 8L8 7L8 5L8 4L8 4L7 4Z",
    id: "a1NnhTZ3k1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 46L11.18 46L11.68 45L2 45L2 11L54 11L54 45L46 45L46 46L55 46L55 1L1 1L1 46ZM2 10L2 2L54 2L54 10L2 10Z",
    id: "cphDewc59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.69 45L20.9 45L19.99 45.91L19.97 46L32.49 46L32.69 45Z",
    id: "f44xXz686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.74 28.54C15.91 28.51 16.78 28.33 18.35 28.02L24.22 33.89L24.92 33.18L18.68 26.93C16.75 27.31 15.68 27.52 15.47 27.57C15.28 27.57 15.07 27.48 14.99 27.4C14.72 27.12 12.54 24.95 12.27 24.68C12.14 24.54 12 24.21 12 24.02C12 23.9 12 23.32 12 22.26L14.3 24.56L17.85 23.85L18.56 20.3L16.26 18C17.32 18 17.9 18 18.02 18C18.21 18 18.54 18.14 18.68 18.27C18.95 18.54 21.12 20.72 21.4 20.99C21.51 21.1 21.59 21.38 21.56 21.54C21.52 21.75 21.31 22.79 20.93 24.68L25.4 29.14L26.11 28.44L22.02 24.35C22.33 22.78 22.51 21.91 22.54 21.73C22.64 21.25 22.45 20.63 22.1 20.28C21.83 20.01 19.66 17.84 19.38 17.56C19.06 17.24 18.48 17 18.02 17C17.74 17 16.35 17 13.85 17L17.48 20.63L17 23L14.63 23.48L11 19.85C11 22.35 11 23.74 11 24.02C11 24.48 11.24 25.06 11.57 25.38C11.75 25.57 12.65 26.47 14.28 28.1C14.93 28.46 15.41 28.6 15.74 28.54Z",
    id: "d1uWZOF670"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.27 39.46C40.09 39.49 39.22 39.67 37.65 39.98L33.56 35.89L32.85 36.6L37.32 41.07C39.25 40.69 40.32 40.48 40.53 40.43C40.72 40.43 40.93 40.52 41.01 40.61C41.28 40.88 43.46 43.05 43.73 43.32C43.87 43.46 44 43.79 44 43.98C44 44.1 44 44.68 44 45.74L41.7 43.44L38.15 44.15L37.44 47.7L39.74 50C38.68 50 38.1 50 37.98 50C37.79 50 37.46 49.87 37.32 49.73C37.05 49.46 34.88 47.28 34.61 47.01C34.49 46.9 34.41 46.62 34.44 46.46C34.48 46.25 34.69 45.21 35.07 43.32L28.82 37.08L28.11 37.79L33.98 43.65C33.67 45.22 33.49 46.09 33.46 46.27C33.36 46.75 33.55 47.37 33.9 47.72C34.17 47.99 36.35 50.17 36.62 50.44C36.94 50.76 37.52 51 37.98 51C38.26 51 39.65 51 42.15 51L38.52 47.37L39 45L41.37 44.52L45 48.15C45 45.65 45 44.26 45 43.98C45 43.52 44.76 42.94 44.44 42.62C44.25 42.43 43.35 41.53 41.72 39.9C41.07 39.54 40.59 39.39 40.27 39.46Z",
    id: "c4RLAXlCzI"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.15 44.92L17.58 47.79L13.38 49.89L12.11 48.62L14.21 44.42L17.08 43.85L27.58 33.35L26.87 32.65L16.59 42.93L13.53 43.54L10.89 48.82L13.18 51.11L18.46 48.47L19.07 45.41L29.35 35.13L28.65 34.42L18.15 44.92Z",
    id: "ajX13Wv89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.74 31.22L26.77 29.19C26.98 29.4 27.1 29.52 27.12 29.55C27.31 29.73 27.55 29.83 27.82 29.83C28.36 29.83 28.8 29.39 28.8 28.85C28.8 28.59 28.69 28.34 28.51 28.16C28.48 28.13 28.37 28.02 28.16 27.8C34.05 21.91 37.33 18.63 37.98 17.97C38.75 17.21 39.77 16.79 40.85 16.79C41.93 16.79 42.95 17.21 43.72 17.97C43.75 18 43.99 18.25 44.02 18.28C44.79 19.05 45.21 20.06 45.21 21.15C45.21 22.23 44.79 23.25 44.02 24.01C43.37 24.67 40.09 27.95 34.2 33.84C33.98 33.63 33.86 33.51 33.84 33.49C33.66 33.31 33.41 33.2 33.15 33.2C32.61 33.2 32.17 33.64 32.17 34.18C32.17 34.45 32.27 34.69 32.45 34.88C32.48 34.9 32.59 35.02 32.81 35.23L30.78 37.26L24.74 31.22ZM30.78 35.85C31.17 35.45 31.39 35.23 31.44 35.19C31.26 34.89 31.17 34.54 31.17 34.18C31.17 33.09 32.06 32.2 33.15 32.2C33.51 32.2 33.85 32.3 34.15 32.47C35.07 31.56 42.4 24.22 43.32 23.31C43.89 22.73 44.21 21.96 44.21 21.15C44.21 20.33 43.89 19.56 43.32 18.99C43.29 18.96 43.04 18.71 43.01 18.68C41.86 17.53 39.85 17.53 38.69 18.68C37.77 19.6 30.44 26.93 29.52 27.85C29.7 28.15 29.8 28.49 29.8 28.85C29.8 29.94 28.91 30.83 27.81 30.83C27.46 30.83 27.11 30.74 26.81 30.56C26.77 30.61 26.55 30.83 26.15 31.22L30.78 35.85Z",
    id: "a67CPpIzC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.65 30.35C33.45 30.16 33.45 29.84 33.65 29.65C34.45 28.85 40.85 22.45 41.65 21.65C41.84 21.45 42.16 21.45 42.35 21.65C42.55 21.84 42.55 22.16 42.35 22.35C41.55 23.15 35.15 29.55 34.35 30.35C34.26 30.45 34.13 30.5 34 30.5C33.87 30.5 33.74 30.45 33.65 30.35Z",
    id: "b6sXlZcvM"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.65 28.35C31.45 28.16 31.45 27.84 31.65 27.65C32.45 26.85 38.85 20.45 39.65 19.65C39.84 19.45 40.16 19.45 40.35 19.65C40.55 19.84 40.55 20.16 40.35 20.35C39.55 21.15 33.15 27.55 32.35 28.35C32.26 28.45 32.13 28.5 32 28.5C31.87 28.5 31.74 28.45 31.65 28.35Z",
    id: "b1onndJHIg"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1tY6m9AsZ",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1tY6m9AsZ",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c1VTy7pOB7",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c1VTy7pOB7",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bSLsf6jAl",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bSLsf6jAl",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1NnhTZ3k1",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1NnhTZ3k1",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cphDewc59",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cphDewc59",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f44xXz686",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f44xXz686",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d1uWZOF670",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d1uWZOF670",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c4RLAXlCzI",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c4RLAXlCzI",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ajX13Wv89",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ajX13Wv89",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a67CPpIzC",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a67CPpIzC",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b6sXlZcvM",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b6sXlZcvM",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1onndJHIg",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1onndJHIg",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHosting3);
export default __webpack_public_path__ + "static/media/hosting-3.7bbeeab571d1fe3966c075de4d6a559c.svg";
export { ForwardRef as ReactComponent };